import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet, Navigate } from "react-router-dom";
import MainDashboard from "./MainDashboard";
import BranchEnquiryApproved from "./Pages/BranchEnquiry/BranchEnquiryApproved";
import BranchEnquiryReceived from "./Pages/BranchEnquiry/BranchEnquiryReceived";
import DefineUserRole from "./Pages/DefineUserRole/DefineUserRole";

import MemberEnquiryPending from "./Pages/MemberEnquriy/MemberEnquiryPending";
import MemberEnquiryReceived from "./Pages/MemberEnquriy/MemberEnquiryReceived";


import EventMaster from "./Pages/Event Master/EventMaster";
import EventExecuted from "./Pages/Event-Program Schedule/EventExecuted";
import EventMapped from "./Pages/Event-Program Schedule/EventMapped";
import EventPending from "./Pages/Event-Program Schedule/EventPending";


import MemberCardGenerated from "./Pages/Member Id Card/MemberCardGenerated";
import MemberCardPending from "./Pages/Member Id Card/MemberCardPending";
import MemberCardApproved from "./Pages/Member Id Card/MemberIdCardApproved";
import MemberRegistration from "./Pages/Member Registration/MemberRegistration";
import EventScheduling from "./Components/Event Scheduling/EventScheduling";
import MemberEnquiryApproved from "./Pages/MemberEnquriy/MemberEnquiryApproved";
import BranchEnquiryPending from "./Pages/BranchEnquiry/BranchEnquiryPending";
import DefineProject from "./Pages/Super Admin/Define Project/DefineProject";
import DefineStateWiseProjectArea from "./Pages/Super Admin/Define state wise Project area/DefineStateWiseProjectArea";
import DepartmentMaster from "./Pages/Super Admin/Department Master/DepartmentMaster";
import DesignationMaster from "./Pages/Super Admin/Designation Master/DesignationMaster";
import DefineEmployee from "./Pages/Super Admin/DefineEmployee/DefineEmployee";
import UserCreation from "./Pages/Super Admin/UserCreation/UserCreation";
import DistrictTalukaWiseMapping from "./Pages/Super Admin/District Taluka wise Surveyor Mapping/DistrictTalukaWiseMapping";
import Login from "./Components/LoginPage/Login";
import ImplementingAgencyDetails from "./Pages/Super Admin/Implementing Agency Details/ImplementingAgencyDetails";
import ProjectWiseSurveyor from "./Pages/Super Admin/ProjectWiseSurveyor/ProjectWiseSurveyor";
import BeneficiaryMaster from "./Pages/Super Admin/BaneficiaryMaster/BeneficiaryMaster";
import AdminDashboard from "./Components/Private/AdminDashboard/AdminDashboard";
import { BeneficiaryDetailsGrid } from "./Components/Private/AdminDashboard/BeneficiaryDetailsGrid/BeneficiaryDetailsGrid";
import { PlantaionDetailsGrid } from "./Components/Private/AdminDashboard/PlantaionDetailsGrid/PlantaionDetailsGrid";
import { BeneficiaryPlotDetailsGrid } from "./Components/Private/AdminDashboard/BeneficiaryPlotDetailsGrid/BeneficiaryPlotDetailsGrid";
import DistrictMaster from "./Pages/Super Admin/DistrictMaster/DistrictMaster";
import TalukaMaster from "./Pages/Super Admin/TalukaMaster/TalukaMaster";
import { GeneralInformationGrid } from "./Components/Private/AdminDashboard/GeneralInformationGrid/GeneralInformationGrid";
import { SamplePlantDetailsGrid } from "./Components/Private/AdminDashboard/SamplePlantDetailsGrid/SamplePlantDetailsGrid";
import FeildStationwiseDistrictMaster from "./Pages/Super Admin/FeildStationwiseDistrictMaster/FeildStationwiseDistrictMaster";
import PlantationDashboard from "./Components/Private/PlantationDashboard/PlantationDashboard";

const AllRoutes = () => {


  const [RoleID, setRoleID] = useState(sessionStorage.getItem("A454A"))

  const RequiredAuth = () => {
    let Auth = sessionStorage.getItem("A454A")
    setRoleID(sessionStorage.getItem("A454A"))
    const location = useLocation()
    if (!Auth) {
      return <Navigate to="/" state={{ from: location }} />
    }
    return <Outlet />
  }

  useEffect(() => {
    setRoleID(sessionStorage.getItem("A454A"))
  }, [RoleID])

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Login />}
        />
        <Route element={<RequiredAuth />}>
          <Route
            path="/Dashboard"
            element={<MainDashboard />}
          />
          <Route
            path="/define-project"
            element={<DefineProject />}
          />

          <Route
            path="/define-state-wise-project-area"
            element={<DefineStateWiseProjectArea />}
          />

          <Route
            path="/Implementingagencydetails"
            element={<ImplementingAgencyDetails />}
          />
          <Route
            path="/District"
            element={<DistrictMaster />}
          />
          <Route
            path="/Taluka"
            element={<TalukaMaster />}
          />
          <Route
            path="/department-master"
            element={<DepartmentMaster />}
          />
          <Route
            path="/designation-master"
            element={<DesignationMaster />}
          />
          <Route
            path="/define-employee"
            element={<DefineEmployee />}
          />
          <Route
            path="/define-user-role"
            element={<DefineUserRole />}
          />
          <Route
            path="/user-creation"
            element={<UserCreation />}
          />

          <Route
            path="/projectwisesurveyor"
            element={<ProjectWiseSurveyor />}
          />

          <Route
            path="/district-taluka-wise-surveyor-mapping"
            element={<DistrictTalukaWiseMapping />}
          />

          <Route
            path="/beneficiaryMaster"
            element={<BeneficiaryMaster />}
          />

          <Route
            path="/FieldStationwiseDistrictMaster"
            element={<FeildStationwiseDistrictMaster />}
          />

          {/* ----------Admin Dashboard ----------- */}

          <Route path="/AdminDashboard" element={<AdminDashboard />} />
          <Route path="/BeneficiaryDetailsGrid" element={<BeneficiaryDetailsGrid />} />
          <Route path="/PlantaionDetailsGrid" element={<PlantaionDetailsGrid />} />
          <Route path="/BeneficiaryPlotDetailsGrid" element={<BeneficiaryPlotDetailsGrid />} />
          <Route path="/GeneralInformationGrid" element={<GeneralInformationGrid />} />
          <Route path="/SamplePlantDetailsGrid" element={<SamplePlantDetailsGrid />} />

        </Route>

        {/* <Route path="/committee-Type" element={<CommiteeType />} />
        <Route path="/executive-committee" element={<ExecutiveCommittee />} /> */}
        <Route path="/member-id-approved" element={<MemberCardApproved />} />
        <Route path="/member-id-pending" element={<MemberCardPending />} />
        <Route path="/member-id-generated" element={<MemberCardGenerated />} />
        <Route path="/create-event-master" element={<EventMaster />} />

        <Route path="/create-event-program" element={<EventMapped />} />
        <Route path="/create-event-executed" element={<EventExecuted />} />
        <Route path="/create-event-pending" element={<EventPending />} />
        <Route path="/member-registration" element={<MemberRegistration />} />
        <Route path="/eventscheduling" element={<EventScheduling />} />



        <Route path="/PlantationDashboard" element={<PlantationDashboard />} />


      </Routes>
    </BrowserRouter>
  );
};

export default AllRoutes;
